import './index.scss';

import { Component } from 'react';

import t from 'utils/i18n';
import oAuth, { ProviderCallbackResponse } from 'utils/oauth';
import { BraxIcon } from '../BraxIcon';

export type BraxOAuthResponse = {
    token: string,
    permissions: string[]
};

export type Brax3thPartyAuthProvider = 'google' /* | 'facebook' */;

export type Brax3thPartyAuthButtonProps = {
    provider: Brax3thPartyAuthProvider,
    permissions: string[],
    redirectURI: string,
    onAuth: (resposne: BraxOAuthResponse) => void,
    onLoadError?: (error?: Error) => void,
    onAuthError?: (error: Error | { error: any }) => void,
    onPermissionError?: () => void
};

export class Brax3thPartyAuthButton extends Component<Brax3thPartyAuthButtonProps> {

    static defaultProps = {
        permissions: []
    };

    readonly PROVIDER_NAMES: { [key in Brax3thPartyAuthProvider]: string } = {
        google: 'Google',
        // facebook: 'Facebook'
    };

    oAuthProvider = this.getInstance();

    componentDidUpdate(prevProps: Brax3thPartyAuthButtonProps) {
        if (prevProps.provider !== this.props.provider)
            this.oAuthProvider = this.getInstance();
    }

    getInstance() {
        return new oAuth[this.props.provider](
            this.props.permissions,
            this.props.redirectURI,
            response => this.handleResponse(response)
        );
    }

    handleResponse(response: ProviderCallbackResponse) {
        if (response === 'permissions-denied')
            this.props.onPermissionError?.();
        else if (response instanceof Error || 'error' in response)
            this.props.onAuthError?.(response);
        else
            this.props.onAuth(response);
    }

    connect(target?: string) {
        this.oAuthProvider.connect(target);
    }

    render() {
        return (
            <button type="button" className={`brax-3th-party-auth-button ${this.props.provider}`} onClick={() => this.connect()}>
                <BraxIcon icon={this.props.provider} />

                <span>{ t('Entrar com %s', this.PROVIDER_NAMES[this.props.provider]) }</span>
            </button>
        );
    }

}
